import {Map} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export default makeReducer<Map<any, any>>(
    [
        match(Actions.fetchAll, () => Map()),

        match(Actions.fetchAllSuccess, (state, {payload}) =>
            Map(payload.drafts.map((draft: any) => [draft.postId, draft])),
        ),

        match(Actions.fetchPostDraftSuccess, (state, {payload}) => state.set(payload.postId, payload.draft)),

        match(Actions.createSuccess, (state, {payload}) => state.update(payload.draft.postId, () => payload.draft)),

        match(Actions.updateSuccess, (state, {payload}) => {
            const {oldDraftId, newDraft} = payload;
            return state.delete(oldDraftId).set(newDraft.postId, newDraft);
        }),

        match(Actions.removeSuccess, (state, {payload}) => state.delete(payload.draftId)),

        match(Actions.sendSuccess, (state, {payload}) => state.delete(payload.draftId)),
    ],
    Map(),
);
